import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Città selezionata ")
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-sm-2 p-md-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome:")
], -1)
const _hoisted_4 = { class: "p-col-9 p-sm-3 p-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.zone.name), 1)
      ])
    ]),
    _: 1
  }))
}